import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TeamManageDialogComponent } from './team-manage-dialog.component';
import { TeamCreateModule } from 'src/app/shared/components/team-create/team-create.module';

@NgModule({
  declarations: [TeamManageDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule, TeamCreateModule],
  exports: [TeamManageDialogComponent],
  entryComponents: [TeamManageDialogComponent],
})
export class TeamManageDialogModule {}
